import { render, staticRenderFns } from "./ServerInfo.vue?vue&type=template&id=083e2ef8&scoped=true"
import script from "./ServerInfo.vue?vue&type=script&lang=js"
export * from "./ServerInfo.vue?vue&type=script&lang=js"
import style0 from "./ServerInfo.vue?vue&type=style&index=0&id=083e2ef8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083e2ef8",
  null
  
)

export default component.exports